"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BurgerMenuTabRoot = exports.BurgerMenuTabPrefixWrapper = exports.BurgerMenuTabLabelWrapper = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const BurgerMenuTabRoot = exports.BurgerMenuTabRoot = (0, _mui.styled)(_mui.ButtonBase, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['isActive', 'fullWidth'])
})(({
  isActive,
  fullWidth,
  theme
}) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.spacing(0, 0, 1, 1),
  color: theme.palette.text.primary,
  display: 'flex',
  fontSize: theme.typography.overline.fontSize,
  fontWeight: theme.typography.fontWeightBold,
  justifyContent: 'flex-start',
  textTransform: 'uppercase',
  width: fullWidth ? '100%' : '50%',
  ...(isActive && {
    backgroundColor: theme.palette.common.white
  }),
  '&::before': {
    fontSize: '2.9rem',
    margin: theme.spacing(0, 3)
  }
}));
const BurgerMenuTabPrefixWrapper = exports.BurgerMenuTabPrefixWrapper = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  isLoggedIn,
  theme
}) => ({
  borderRadius: '50%',
  display: 'flex',
  fontSize: '2.9rem',
  margin: theme.spacing(3, 2),
  svg: {
    width: 24,
    height: 24
  },
  ...(isLoggedIn && {
    borderRadius: '50%',
    color: theme.palette.common.white,
    display: 'flex',
    fontSize: '2.6rem',
    height: 26
  })
}));
const BurgerMenuTabLabelWrapper = exports.BurgerMenuTabLabelWrapper = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  fullWidth
}) => ({
  marginRight: theme.spacing(fullWidth ? 2 : 3),
  overflow: 'hidden',
  textAlign: 'left',
  textOverflow: 'ellipsis',
  width: fullWidth ? '100%' : 'auto'
}));